(function () {
  "use strict";
  if (window.mivioWaitlistTrackingReady) return;
  window.mivioWaitlistTrackingReady = true;

  var formId = "obZbpP";
  var seen = new Set();
  window.addEventListener("message", function (event) {
    if (event.origin !== "https://tally.so") return;
    var frame = document.querySelector('iframe[title="Join the Waitlist"]');
    if (!frame || event.source !== frame.contentWindow) return;

    var message;
    try {
      message = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
    } catch (_) { return; }
    if (!message || message.event !== "Tally.FormSubmitted") return;
    var submission = message.payload;
    if (!submission || submission.formId !== formId || typeof submission.id !== "string"
      || !/^[A-Za-z0-9_-]{1,128}$/.test(submission.id)) return;
    if (typeof window.fbq !== "function") return;

    // Only successful submissions count. Never pass answers or contact details.
    var eventId = "mivio-waitlist-" + submission.id;
    var storageKey = "mivio:lead:" + eventId;
    if (seen.has(eventId)) return;
    try { if (window.sessionStorage.getItem(storageKey)) return; } catch (_) {}
    window.fbq("trackSingle", "2184018475850941", "Lead", {}, { eventID: eventId });
    seen.add(eventId);
    try { window.sessionStorage.setItem(storageKey, "1"); } catch (_) {}
  });
})();
